// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.szbyz{padding:32px 24px;border:1px solid #e2e8f0;border-radius:12px;background:#fff}
.kKQEd{font-size:28px;font-weight:700;color:#1e293b;margin-bottom:12px}
.qgE9X{color:#64748b;font-size:16px;line-height:1.6;margin-bottom:24px}
.lzgnD{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:12px}
.Vi8_d{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px}
.jubIF{color:#334155;font-size:15px}
.TFuJu{color:#16a34a}
.o604O{color:#64748b}
.GlC6R{padding:32px 24px;border:1px solid #fecaca;border-radius:12px;background:#fef2f2}
.bZrcG{font-size:24px;font-weight:700;color:#991b1b;margin-bottom:12px}
.hztUX{color:#7f1d1d;font-size:16px;line-height:1.6}
.w0IRb{min-height:100vh;background:#f8fafc;padding:48px 16px}
.tuv78{max-width:900px;margin:0 auto;background:#fff;border-radius:12px;padding:32px 24px;-webkit-box-shadow:0 1px 3px rgba(15,23,42,.08);box-shadow:0 1px 3px rgba(15,23,42,.08)}
.Cimk4{text-align:center;margin-bottom:28px}
.yVo1B{height:40px;width:auto}
.TmpUS{font-size:30px;font-weight:700;color:#1e293b;margin-bottom:8px}
.S9hfA{color:#64748b;font-size:16px;margin-bottom:24px}
.OvYDt{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"submittedContainer": `szbyz`,
	"submittedTitle": `kKQEd`,
	"submittedSubtitle": `qgE9X`,
	"statusList": `lzgnD`,
	"statusItem": `Vi8_d`,
	"statusText": `jubIF`,
	"checkIcon": `TFuJu`,
	"clockIcon": `o604O`,
	"errorContainer": `GlC6R`,
	"errorTitle": `bZrcG`,
	"errorMessage": `hztUX`,
	"pageContainer": `w0IRb`,
	"pageCard": `tuv78`,
	"pageLogoWrap": `Cimk4`,
	"pageLogo": `yVo1B`,
	"pageTitle": `TmpUS`,
	"pageSubtitle": `S9hfA`,
	"setupPanel": `OvYDt`
};
module.exports = ___CSS_LOADER_EXPORT___;
